import axios from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { CACHE_KEYS } from '../constants';
import { Response, components } from '@inpart-io/api-v3-types';

export type User = Response<'get', '/api/v3/users/me'>['data'];
export type UserGroup = components['schemas']['UserGroupAlias'];

/**
 * Fetches user details from the API to determine
 * if we have a logged-in user
 */
export const useAuthCheckV3 = (): UseQueryResult<User | undefined> => {
  return useQuery(CACHE_KEYS.USER, async () => {
    try {
      return (await axios.get<Response<'get', '/api/v3/users/me'>>('/api/v3/users/me')).data.data;
    } catch (err) {
      // If the error is a 401 then it just means the user isn't
      // logged in, not that the query failed, so we can just return
      // undefined (ie, no user)
      if (err.response.status === 401) {
        return undefined;
      } else {
        throw err;
      }
    }
  });
};
